// Compatibility shim: the milestone table column still imports StepperCell, but the dot rendering now lives in ProgressDots.

import type { Milestone } from "../../../../types";
import ProgressDots from "./ProgressDots";

interface StepperCellProps {
  milestone: Milestone;
}

export default function StepperCell({ milestone }: StepperCellProps) {
  return <ProgressDots milestone={milestone} />;
}
